import React from 'react';
import { cn } from '../utils';

type TProps = React.SVGProps<SVGSVGElement>;

const ArrowIcon = (props: TProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.70538 9.29464C7.09466 8.90537 7.72569 8.90503 8.11538 9.29387L11.2937 12.4652C11.684 12.8547 12.316 12.8547 12.7063 12.4652L15.8846 9.29387C16.2743 8.90503 16.9053 8.90537 17.2946 9.29464C17.6842 9.68422 17.6842 10.3158 17.2946 10.7054L12.7071 15.2929C12.3166 15.6834 11.6834 15.6834 11.2929 15.2929L6.70538 10.7054C6.31581 10.3158 6.31581 9.68422 6.70538 9.29464Z"
        fill="currentColor"
      />
    </svg>
  );
};

ArrowIcon.Down = ArrowIcon;

ArrowIcon.Up = ({ className, ...props }: TProps) => (
  <ArrowIcon className={cn('rotate-180', className)} {...props} />
);
ArrowIcon.Left = ({ className, ...props }: TProps) => (
  <ArrowIcon className={cn('rotate-90', className)} {...props} />
);
ArrowIcon.Right = ({ className, ...props }: TProps) => (
  <ArrowIcon className={cn('-rotate-90', className)} {...props} />
);

export default ArrowIcon;
